import Decision from "slotworks/state-machine/decisions/decision";
import gameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import BonusRecord from "integration/revolver/schema/bonus-record";

export default class FreespinsActive extends Decision {

    public evaluate() {
        const record = gameState.getCurrentGame().latestRecord();

        let inFreespins;

        if (record instanceof FreespinRecord) {
            inFreespins = true;
        }

        if(record instanceof BonusRecord) {
            inFreespins = record.inFreespins;
        }

        if (record.beenPaid) {
            inFreespins = false;
        }

        return inFreespins ? Exit.True : Exit.False;
    }

}